import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { SystemSiteService } from 'app/services/system-site.service';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-referrals',
  templateUrl: './referrals.component.html',
  styleUrls: ['./referrals.component.scss']
})
export class ReferralsComponent {
closeResult: string;
  submitState: 'pending' | 'success' | 'error' = 'pending';
  selected_department: String = "Sales";
  contactUsForm: UntypedFormGroup;
  sendEmailSubscription: Subscription;
  socialData: any = []
  branchData: any = []
  packageData: any = []
  socialSubscription: Subscription = null;
  branchSubscription: Subscription = null;
  parameterSubscription: Subscription = null;
  newsSubscription

  center: google.maps.LatLngLiteral = { lat: -26, lng: 28 };
  zoom = 14;
  markerOptions: google.maps.MarkerOptions = { draggable: false };
  markerPositions: any[] = [];


  constructor(private fb: UntypedFormBuilder, private recaptchaV3Service: ReCaptchaV3Service, private systemSiteService: SystemSiteService, private modalService: NgbModal, private router: Router, private route: ActivatedRoute) {

    this.contactUsForm = this.fb.group(
      {
        website: [''],
        referral_identifier: ['', Validators.required],
        practice_number: ['', Validators.required],
        first_name: ['', Validators.required],
        last_name: ['', Validators.required],
        email: ['', [Validators.required, Validators.email]],
        mobile: ['', Validators.required],
      }
    )

  }

  get f() {
    return this.contactUsForm.controls;
  }

  ngOnInit() {
    var body = document.getElementsByTagName('body')[0];
    body.classList.add('contact-page');
    this.LoadData();

    this.parameterSubscription = this.route.params.subscribe(params => {

   
      

          if (params.practice_number && params.practice_number != '' && params.practice_number != 'None') {

            this.packageData = params.data;
            this.contactUsForm.patchValue({"practice_number" : params.practice_number })
          }
       
        

          if (params.email && params.email != ''  && params.email != 'None') {

            this.packageData = params.data;
            this.contactUsForm.patchValue({ "referral_identifier":  params.email, })
          }
       



    });




  }


  getPosition(lat: any, lng: any): any {
    return { lat: parseFloat(lat), lng: parseFloat(lng) }
  }





  LoadData() {
    this.socialSubscription = this.systemSiteService.get_social().subscribe({
      next: data => {
        console.log(data.result_data)
        this.socialData = data.result_data;
      },
      error: error => { console.log(error) },
    })


    this.branchSubscription = this.systemSiteService.get_branch().subscribe({
      next: data => {
        console.log(data.result_data)
        this.branchData = data.result_data;



      },
      error: error => { console.log(error) },
    })


  }


  ngOnDestroy() {
    var body = document.getElementsByTagName('body')[0];
    body.classList.remove('contact-page');




    if (this.socialSubscription)
      this.socialSubscription.unsubscribe();
    if (this.branchSubscription)
      this.branchSubscription.unsubscribe();
    if (this.sendEmailSubscription)
      this.sendEmailSubscription.unsubscribe();



  }

  delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async open(content, type) {
    if (type === 'sm') {
      console.log('aici');
      this.modalService.open(content, { size: 'sm' }).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    } else {

      this.submitState = 'pending';

      this.modalService.open(content).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });

      let formValues = this.contactUsForm.getRawValue();

      this.sendEmailSubscription = this.recaptchaV3Service.execute('referral_form').pipe(
        switchMap((token) => {
          formValues.recaptcha_token = token;
          return this.systemSiteService.referral_form_email(formValues);
        })
      ).subscribe({
        next: async () => {
          this.submitState = 'success';
          await this.delay(1500);
          this.modalService.dismissAll();
          this.router.navigate(['']);
        },
        error: (error) => {
          console.log(error);
          this.submitState = 'error';
        },
      })
    }
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }







}
